import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { SkeletonUnit } from '../../SkeletonUnit'
import {
  SkeletonUnitDirection,
  SkeletonUnitPaddings,
} from '../../SkeletonUnit.h'

export interface ITopPartSkeletonUnitProps extends ISkeletonUnitProps {}

export const TopPartSkeletonUnit = ({
  children,
  direction = SkeletonUnitDirection.Column,
  paddings = SkeletonUnitPaddings.SIZE_10,
  ...rest
}: ITopPartSkeletonUnitProps): JSX.Element => (
  <SkeletonUnit direction={direction} paddings={paddings} {...rest}>
    {children}
  </SkeletonUnit>
)
